import * as React from 'react';
import { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../_auth/AuthContext';
import { IUserState } from '../_types/user';


interface Props {

};

const SnapShot: React.FC<Props> = (prop: Props) => {
const userState: IUserState = useContext(AuthContext);

return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch">
          <Grid item>Reports DashBoard
            { userState.user.displayName  } 

          </Grid>
    </Grid>
)
}

export default SnapShot;